import React from 'react';
import PropTypes from 'prop-types';
import { InformationModal } from 'web-ui-components/lib/layout/content';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { List } from 'web-ui-components/lib/atoms/text';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import withContent from '../../containers/withContent';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import authoriserContent, { contentPropTypes } from './AuthoriserViewer.content';
import { GenericDivider } from 'web-ui-components/lib/layout/content';
import { ShellInnerSpacer } from 'web-ui-components/lib/layout/shells';
class AuthoriserViewer extends React.Component {
	constructor(props) {
		super(props);

		this.handleClose = this.handleClose.bind(this);
	}

	handleClose() {
		this.props.onClose();
	}

	render() {
		const { singleAuthorisersList, multiAuthorisersList, isOpen, content } = this.props;

		const showSingleList = singleAuthorisersList.length > 0;
		const showMultiList = multiAuthorisersList.length > 1;

		const noUsers = !showMultiList && !showSingleList;

		const renderAuthorListItem = (authoriser) => ({
			id: authoriser.id,
			text: authoriser.name,
			icon: <Icon iconType="PersonOutlineLarge" color="utility-tip" />,
		});

		const buttons = [<NavigationButton.Primary labelText={content.confirmButtonLabel} onClick={this.handleClose} />];

		return (
			<InformationModal
				buttons={buttons}
				titleText={noUsers ? content.noUsersTitle : content.title}
				isOpen={isOpen}
				onClose={this.handleClose}
			>
				{(showSingleList || showMultiList) && (
					<StandardBody>
						<p>{content.subText}</p>
					</StandardBody>
				)}
				{noUsers && (
					<StandardBody>
						<p>{content.noUsers}</p>
					</StandardBody>
				)}

				<div className="jon-doe">
					{showSingleList && (
						<div>
							<StandardBody>
								<p>{`${content.singleListHeader} (${singleAuthorisersList.length})`}</p>
							</StandardBody>
							<ShellInnerSpacer>
								<List items={singleAuthorisersList.map(renderAuthorListItem)} />
							</ShellInnerSpacer>
						</div>
					)}
					{showSingleList && showMultiList && <GenericDivider />}
					{showMultiList && (
						<div>
							<StandardBody>
								<p>{`${content.multiListHeader} (${multiAuthorisersList.length})`}</p>
							</StandardBody>
							<ShellInnerSpacer>
								<List items={multiAuthorisersList.map(renderAuthorListItem)} />
							</ShellInnerSpacer>
						</div>
					)}
				</div>
			</InformationModal>
		);
	}
}

AuthoriserViewer.propTypes = {
	singleAuthorisersList: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })),
	multiAuthorisersList: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })),
	onClose: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired,
	paymentId: PropTypes.string,
	content: PropTypes.shape(contentPropTypes),
	userId: PropTypes.string,
};

export default withContent({ content: authoriserContent })(AuthoriserViewer);
export { AuthoriserViewer };
